import React from 'react';
import { Apple, Smartphone } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../mock';

const AppDownloadSection = () => {
  return (
    <section id="download" className="py-20 bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Get the <span className="text-yellow-400">bHyyve</span> App
          </h2>
          <p className="text-white/80 text-lg mb-12 max-w-2xl mx-auto">
            Download our mobile app and access thousands of services and products at your fingertips.
            Available on iOS and Android.
          </p>

          <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {/* iOS App */}
            <a
              href={mockData.appLinks.ios}
              className="group bg-white/10 backdrop-blur-sm hover:bg-yellow-400 border-2 border-white/20 hover:border-yellow-400 rounded-2xl p-8 transition-all duration-300"
            >
              <Apple className="mx-auto mb-4 group-hover:text-black text-white transition-colors" size={48} />
              <h3 className="text-2xl font-bold mb-2 group-hover:text-black transition-colors">iOS App</h3>
              <p className="text-white/70 group-hover:text-black/70 transition-colors">
                Download on the App Store
              </p>
              <Button className="mt-6 bg-yellow-400 text-black hover:bg-yellow-500 group-hover:bg-black group-hover:text-yellow-400 w-full font-semibold">
                Download for iPhone
              </Button>
            </a>

            {/* Android App */}
            <a
              href="https://play.google.com/store/apps/details?id=com.customers.bhyyve"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white/10 backdrop-blur-sm hover:bg-yellow-400 border-2 border-white/20 hover:border-yellow-400 rounded-2xl p-8 transition-all duration-300"
            >
              <Smartphone className="mx-auto mb-4 group-hover:text-black text-white transition-colors" size={48} />
              <h3 className="text-2xl font-bold mb-2 group-hover:text-black transition-colors">Android App</h3>
              <p className="text-white/70 group-hover:text-black/70 transition-colors">
                Get it on Google Play
              </p>
              <Button className="mt-6 bg-yellow-400 text-black hover:bg-yellow-500 group-hover:bg-black group-hover:text-yellow-400 w-full font-semibold">
                Download for Android
              </Button>
            </a>
          </div>

          <div className="mt-12 bg-yellow-400/10 border-2 border-yellow-400/30 rounded-2xl p-6">
            <p className="text-white/90">
              <span className="font-bold text-yellow-400">Coming Soon:</span> Enhanced features,
              real-time notifications, and exclusive app-only deals!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownloadSection;